module.exports = __webpack_public_path__ + "static/img/5210_phase_function_Paper_PointsHejduk_Prediction.5d6e353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5210_phase_function_Paper_PointsHejduk_Prediction.png
// module id = K6bY
// module chunks = 0